import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TsplatFilterOpacityIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M15.79 4.49999C14.62 3.09999 13.52 1.78999 12.89 0.549985C12.55 -0.120015 11.45 -0.120015 11.11 0.549985C10.48 1.78999 9.38 3.09999 8.21 4.49999C5.77 7.41999 3 10.72 3 15C3 19.96 7.04 24 12 24C16.96 24 21 19.96 21 15C21 10.72 18.23 7.41999 15.79 4.49999ZM12 22C8.14 22 5 18.86 5 15C5 11.45 7.41 8.56999 9.74 5.77999C10.56 4.79999 11.34 3.85999 12 2.91999C12.65 3.85999 13.44 4.79999 14.26 5.77999C16.59 8.56999 19 11.45 19 15C19 18.86 15.86 22 12 22Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TsplatFilterOpacityIcon.displayName = 'TsplatFilterOpacityIcon';
